Prepayments = {

    module: '/predoplata',


    FormValidation: function () {

        // http://jqueryvalidation.org/validate/
        //console.log(this);

        var self = this,
            url = self.module + '/enter',
            form = $('#prepayment_form'),
            msg_place = $('.js_msg', form),
            additional_form_data;

        validator = form.validate({
            //debug: true, // also prevents submit!

            // input el classes
            //errorClass: "invalid_input_el",
            //validClass : "valid_input_el",

            // error label
            // The problem is that you cannot remove success class after it's there!!!! There is no 'error' handler function
            //success: "valid_label_el", // class for the error msg el if input is valid
            //errorElement: "div", // a bug: error class is not removed
            //success: function(label) {
            //  console.log('success func is called!');
            //  label.addClass("valid_label_el").text("Ok!");
            //},

            rules: {

                // Способ оплаты
                paymentType: {
                    required: true
                },

                // сумма в рублях
                sum: {
                    required: true
                    , number: true

                },

                // Телефон для связи
                customerNumber: {
                    required: true
                    , number: true

                },

                //ФИО плательщика
                custName: {
                    required: true
                    , minlength: 5
                },

                // Адрес электронной почты
                custEmail: {
                    required: true
                    , email: true
                },


                // Назначение платежа
                orderDetails: {
                    required: true

                }

            },

            messages: {
                password: {
                    oneWord: "Пароль не должен содержать пробелов."
                }
            },


            /**
             *
             * this handler is passes the form element
             */
            submitHandler: function (form) {
                //console.log('submitHandler');

                form.submit(); // submit the form
                //return true; // does NOT submit the form
                //return false; // does NOT submit the form
                //self.sendFormDataToServer(url, form, additional_form_data, msg_place, form);

            }

        });

    }

}


